import { Suspense } from 'react';

import { Outlet, type RouteObject } from 'react-router-dom';

import { LoadingScreen } from '@tankef/ui';

import { experienceRoutes } from './experience-routes';
import { productRoutes } from './product-routes';
import { walletRoutes } from './wallet-routes';
import { ProtectedRoute } from '../guards/ProtectedRoute';
import { DashboardLayout } from '../layouts/DashboardLayout';

export function clientRoutes(): RouteObject[] {
  return [
    {
      element: <ProtectedRoute />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            {
              element: (
                <Suspense fallback={<LoadingScreen />}>
                  <Outlet />
                </Suspense>
              ),
              children: [...experienceRoutes(), ...walletRoutes(), ...productRoutes()],
            },
          ],
        },
      ],
    },
  ];
}
